module.exports = __webpack_public_path__ + "media/src/images/temp/iversity-buchmesse-books-image_1-75e09ed2d2c067adc4418c14bde2572f.png";